exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-picker[data-v-132c4787] {\n  margin: 16px 0px;\n}\n.red[data-v-132c4787] {\n  color: #B11D1D;\n  font-size: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-132c4787","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/widrawalRequest/DelegateModal.vue
// module id = 0UO6
// module chunks = 1